<template>
  <transition name="fade">
    <div 
      class="pop-right-click"
      :style="{ left: popoverLeft + 'px', top: popoverTop + 'px'}" 
      width="260" 
      v-show="visible">

      <div class="menu-title">五域订单号：{{ item.orderNo }}</div>
      <div class="menu-list">
        <li v-if="permission.includes('submitOrder')"@click="onEmit('onSubmitOrder')">提交订单</li>
        <li v-if="permission.includes('resubmitOrder')"@click="onEmit('onResubmit')">重新提交</li>
        <li v-if="permission.includes('modifyOrderAmount')"@click="onEmit('onGoodsAmount')">修改下单金额</li>
        <li v-if="permission.includes('submitBonusApply')" @click="onEmit('onSubmitApply')">发起提成申诉</li>
        <li v-if="permission.includes('getBonusApplyDetail')"@click="onEmit('onCheckApply')">查看提成申诉</li>
        <li v-if="permission.includes('cancelBonusApply')" @click="onEmit('onRevokeApply')">撤销申诉</li>
        <li v-if="permission.includes('directModifyBonus')" @click="onEmit('onSubmitApplyEdit')">发起修改提成</li>
        <li  v-if="permission.includes('auditBonusApply')" @click="onEmit('onConfirmModify')">确认修改提成</li>
        <li v-if="permission.includes('confirmReceipt')" @click="onEmit('onConfirmReceipt')">确认收货</li>
        <li v-if="permission.includes('cancelOrder')"@click="onEmit('onCancelOrder')">取消订单</li>
        <li v-if="permission.includes('specifyExpress')"@click="onEmit('onSetExpress')">指定快递</li>
        <li v-if="permission.includes('orderDetail')"@click="onEmit('onDetail')">订单详情</li>
        <li v-if="permission.includes('setTag')"@click="onEmit('onSetTag')">设置标签</li>
        <li v-if="permission.includes('specifyDeliveryDate')"@click="onEmit('onSetDate')">指定发货日期</li>
        <li v-if="permission.includes('fixMissingProductCode')"@click="onEmit('onGoodsInfoEdit')">修复商品编码缺失</li>
        <li v-if="permission.includes('customerServiceRemark')"@click="onEmit('onSetRemark')">客服备注</li>
        <li v-if="permission.includes('orderOperationRecord')"@click="onEmit('onOrderRecord')">订单操作记录</li>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'popRightClick',
  data() {
    return {
      visible: false,
      popoverLeft: 0, // 动态设置left值
      popoverTop: 0,   // 动态设置top值
      item: {},
      permission:[]
    }
  },
  methods: {
    show(row,x,y) {
        this.item = row
        // 获取显示的高度
        const postData = { orderNo: row.orderNo }
        this.visible = false
        this.$api.omsCheckMenu(postData).then((res) => {
          if (res.code == 0) {
            let tempList = res.data.actionItems
            let permission = []
            tempList.forEach(e => {
              if (e.actionable) {
                permission.push(e.actionCode)
              }
            })
            // 可操作个数
            let buttonCount = res.data.actionableCount
            this.permission = permission
              // console.log('permission：',permission,buttonCount)
            this.popoverLeft = x + 10
            this.popoverTop = y

            const windowHeight = window.innerHeight
            const windowWidth = window.innerWidth
            const popoverHeight = Math.ceil(buttonCount*36 + 52)
            const popoverWidth = 260
            
            // 底部边界检测
            if (y + popoverHeight > windowHeight) {
              this.popoverTop = windowHeight - popoverHeight
            }
            // 右侧边界检查
            if (x + popoverWidth > windowWidth) {
              this.popoverLeft = x - popoverWidth - 10
            }
            
            this.visible = true
          }
        })
        
    },
    handleClickOutside(event) {
      // 如果点击的是弹窗外部，则隐藏弹窗
      if (this.visible && !event.target.closest('.pop-right-click')) {
        this.visible = false
      }
    },
    onEmit(type){
      let data = {
        type:type,
        item:this.item
      }
      this.$emit('hasClickMenu',data)
      this.visible = false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style lang='scss'>
  .pop-right-click{
    width: 260px;
    // background-color: #FFF;
    border-radius: 4px;
    position: fixed;
    overflow: hidden;
    z-index: 10;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    
    .menu-title{
      height: 40px;
      line-height: 40px;
      background-color: #409EFF;
      font-size: 12px;
      color: #FFF;
      text-indent: 21px;
    }
    .menu-list{
      background-color: #FFF;
      li{
        line-height: 35px;
        border-bottom: 1px solid #EFEFEF;
        text-indent: 20px;
        list-style: none;
        cursor: pointer;
        font-size: 12px;
        &:last-child{
          border-bottom: none;
          padding-bottom: 1px;
        }
        &:hover{
          color: #409EFF;
          background-color: #E3F0FC;
        }
      }
    }
  }

  /* 优化过渡动画效果 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>